exports = module.exports = require("../../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2vu_5MbfnH3PoGW3lnupuN{color:\"[theme:neutralSecondary, default:#605e5c]\"}html[dir] ._2vu_5MbfnH3PoGW3lnupuN{margin:0 4px 0 4px}._2vu_5MbfnH3PoGW3lnupuN:hover{color:\"[theme:black, default:#000000]\"}html[dir=ltr] ._2aP3IBGCfBxPUMhJBSaX71{padding:3px 12px 20px 0}html[dir=rtl] ._2aP3IBGCfBxPUMhJBSaX71{padding:3px 0 20px 12px}", ""]);
// Exports
exports.locals = {
	"icon": "_2vu_5MbfnH3PoGW3lnupuN",
	"iconContainer": "_2aP3IBGCfBxPUMhJBSaX71"
};